import React, { useEffect, useState } from 'react';
import { BadgeImageBackgroundColors, BadgeImageLabel } from './BadgeImage.enum';
import { Flags } from '../../../Cloud.model';
import { StyledBadge } from './BadgeImage.styled';

type Badges = {
    label: string;
    backgroundColor: string;
}[]

export interface UHCBadgeImageProps {
    flags: Flags[];
}

const UHCBadgeImage: React.FC<UHCBadgeImageProps> = (props: UHCBadgeImageProps) => {
    const [badges, setBadges] = useState<Badges>([]);


    useEffect(() => {
        if (!props.flags) return

        props.flags.map(flag => {
            setBadges(badge => [...badge, { label: BadgeImageLabel[flag], backgroundColor: BadgeImageBackgroundColors[flag] }]);
        })
    }, [])



    return (
        <>
            {badges.map((badge) => {

                return <StyledBadge key={badge.label + badge.backgroundColor} text={badge.label || ''} textColor='white' backgroundColor={badge.backgroundColor} />
            })}
        </>

    );
};

export default UHCBadgeImage;